export const name = 'ks/ui/form';

export const CHANGE_FORM_STEP = `${name}/changeStep`;
export const CHANGE_FORM_COMPLETED_FLAG = `${name}/fromCompleted`;

export const RESET_FORM = `${name}/resetForm`;



